// ────────────────────────────────────────────────────────────────────
// Shared CML data-quality flag copy (workbench roadmap C1/C3). The
// backend (server/routers/corrosion.py::_dq_flags) emits domain flags
// on a CmlRow's `dq` array — a survey value that looks like a data-entry
// error, not real corrosion. Both the client AssetWorkspaceScreen's CML
// table and the staff DeskScreen's CML table render the SAME amber
// marker + tooltip copy from this one place — do not restate the labels
// inline in either screen.
// ────────────────────────────────────────────────────────────────────
export const DQ_FLAG_LABEL: Record<string, string> = {
  possible_doubling: "ค่าโดดเป็นสองเท่า — อาจกรอกผิด",
  non_monotonic: "ค่าเพิ่มขึ้นผิดปกติ",
};

/** Human tooltip text for a CmlRow's `dq` flags, or null if there are none. */
export function dqTooltip(dq: string[] | undefined | null): string | null {
  if (!dq || dq.length === 0) return null;
  return dq.map((f) => DQ_FLAG_LABEL[f] ?? f).join(" · ");
}
